import LoadingButton from "@mui/lab/LoadingButton";
import {
  Box,
  Grid,
  IconButton,
  Typography
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Report } from "../../models/reporting/report";
import { ReportDetailsForm } from "./ReportDetailsForm";
import { Trash } from "react-feather";
import { useEditReport } from "../../hooks/reporting/useEditReport";
import { useDeleteReport } from "../../hooks/reporting/useDeleteReport";

type EditReportProps = {
  handleClose: () => void;
  report: Report;
};

export const EditReport = ({ handleClose, report }: EditReportProps) => {

  const [error, setError] = useState("");

  const editReport = useEditReport({
    onSuccess: () => {
      handleClose();
    },
    onError: (error: Error) => {
      setError(error.message);
    }
  });

  const deleteReport = useDeleteReport({
    onSuccess: () => {
      handleClose();
    },
    onError: (error: Error) => {
      setError(error.message);
    }
  });

  const { resetForm, ...formik } = useFormik({
    initialValues: {
      title: report.title,
      type: report.type,
      entity: report.entity,
      visualScale: report.visualScale,
      data: {
        xAxis: report.data.xAxis,
        yAxis: report.data.yAxis,
        period: report.data.period,
        isAnonymised: report.data.isAnonymised
      },
      filters: report.filters
    },
    onSubmit: async (values) => {
      editReport.mutate({ reportId: report.id, values });
    },
    enableReinitialize: true
  });

  useEffect(() => {
    resetForm();
    setError("");
  }, [resetForm, setError]);

  return (
    <>
      <Box display="flex">
        <Box ml="auto" p={2}>
          <IconButton
            onClick={() => deleteReport.mutate(report.id)}
            color="error"
            style={{ marginLeft: "auto" }}
          >
            <Trash />
          </IconButton>
        </Box>
      </Box>

      <form onSubmit={formik.handleSubmit}>
        <Box padding={2}>
          <Grid container spacing={2}>
            {error && (
              <Grid item xs={12}>
                <Typography color="error">{error}</Typography>
              </Grid>
            )}
            <Box sx={{ width: "100%", px: 2, pt: 1 }}>
              <ReportDetailsForm form={formik} />
            </Box>
          </Grid>
        </Box>
        <Box padding={2}>
          <LoadingButton
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            loading={editReport.isLoading}
          >
            Save
          </LoadingButton>
        </Box>
      </form>
    </>
  );
};
